import { get, isArray, isEmpty } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import getGqlOperationName from '../../utils/getGqlOperationName';
import query from '../organisationGroupSelectorQuery.graphql';
const useOrganisationGroups = (params = {}, { skip = false } = {}) => {
    const { initialSelect = [], tenantId } = useMemo(() => (isArray(params) ? { initialSelect: params } : params || {}), [params]);
    const variables = useMemo(() => {
        const variables = {};
        if (tenantId) {
            variables.tenantId = tenantId;
        }
        if (!isEmpty(initialSelect)) {
            variables.selectedValues = initialSelect;
        }
        return variables;
    }, [tenantId, initialSelect]);
    const { error, loading, data } = useQuery(query, {
        variables,
        fetchPolicy: 'cache-first',
        skip,
    });
    const models = useMemo(() => get(data, getGqlOperationName(query), []), [
        data,
    ]);
    return { models, error, loading };
};
export default useOrganisationGroups;
